import { stringify } from "query-string";
import { getData, postdData, postUrl } from "../../../Context/backend";
import validator from "validator";
import { IMG } from "../../../Lib/Funciones Generales/Constantes";

///////////////////
/* FUNCIONES GET */
///////////////////


export const getAccesos = async () => {
  //onsole.log(query)
  let data = []; 
  const url = `GruposAcceso/getAccesos`;
  const res = await getData(url);
  return new Promise((resolve, reject) => {
    if (!res.error) {
      data = res.data.respuesta;
      resolve(JSON.parse(data.data));
    } else {
      reject(res);
    }
  });
};
export const getLista = async (iTake, iSkip, Order, query) => {
  //onsole.log(query)
  let data = [];
  let queryParamsObj = {
    iTake: iTake,
    iSkip: iSkip,
    Order: Order,
    query: query,
  };
  const url = `GruposAcceso/Listar?${stringify(queryParamsObj)}`;
  const res = await getData(url);
  return new Promise((resolve, reject) => {
    if (!res.error) {
      data = res.data.respuesta;
      resolve(data);
    } else {
      reject(res);
    }
  });
};

export const getInfoGrupo = async (id, imgDefault) => {
  let data = [];
  let queryParamsObj = {
    id: id,
  };

  const url = `GruposAcceso/Consultar?${stringify(queryParamsObj)}`;
  const res = await getData(url);
  return new Promise((resolve, reject) => {
    if (!res.error) {
      data = JSON.parse(res.data.respuesta.data);
      //console.log(data);
      if (data.length == 0) {
        resolve({
          err: [],
          mensaje: "No se encontró información de este empleado",
        });
      } else {
        data = JSON.parse(res.data.respuesta.data)[0];
       let accesos = JSON.parse(res.data.respuesta.accesos);
        let Values = {
          id: String(data.ID),
          nombre: String(data.NOMBRE),
          permisos:  accesos,
          
        };
        resolve(Values);
      }
    } else {
      reject({
        mensaje: "Error al conectar a internet, revisa tu conexion a internet",
      });
    }
  });
};

export const getOpciones = async (ID) => {
  let data = [];
  let queryParamsObj = {
    ID_SUCURSAL: ID,
  };
  const url = `GruposAcceso/getOpciones?${stringify(queryParamsObj)}`;
  const res = await getData(url);
  return new Promise((resolve, reject) => {
    if (!res.error) {
      data = res.data.respuesta;
      // console.log(data);
      resolve(data);
    } else {
      reject(res);
    }
  });
};

////////////////////
/* FUNCIONES POST */
////////////////////
export const guardar = async (Values, Errores, setErrores, permisos) => {
  let error = false;

  if (!Values.nombre || Values.nombre == "") {
    let Errores2 = Errores;
    Errores2.nombre = true;
    setErrores(Errores2);
    error = true;
  }


  if(permisos.length ==0 )
  {

    return new Promise((resolve, reject) => {
      resolve({ mensaje: "Selecciona al menos un permiso para este grupo" });
    });

  }

 

  if (!error) 
  {
    
    let data = [];
    const body = {
      permisosString: JSON.stringify(permisos) ,
      NOMBRE: Values.nombre,
    ID: Values.id,
    permisos:permisos
    };  
 

    const url =
      Values.id == undefined || Values.id == "" || Values.id == 0
        ? "GruposAcceso/Insertar"
        : "GruposAcceso/Editar";
    const res = await postdData(url, body);
    return new Promise((resolve, reject) => {
      if (!res.error) {
        data = res.data;
        resolve(data);
      } else {
        reject(res);
      }
    });
  } else {
    return new Promise((resolve, reject) => {
      resolve({ mensaje: "Completa todos los campos requeridos" });
    });
  }
};

 
export const Eliminar = async (id) => {
  if (id != undefined) {
    let data = [];
    let queryParamsObj = {
      id: id,
    };
    const url = `GruposAcceso/Eliminar?${stringify(queryParamsObj)}`;
    const res = await postUrl(url);
    return new Promise((resolve, reject) => {
      if (!res.error) {
        data = res.data;
        resolve(data);
      } else {
        reject(res);
      }
    });
  } else {
    return new Promise((resolve, reject) => {
      resolve({ mensaje: "No se pudo obtener el identificador" });
    });
  }
};
  